import React from "react";
import "./ApplicationProcess.css";
import processImg from "../../Assets/career/applicationprocess.png"; // Replace with your actual image path
import vcnrLogo from "../../Assets/vcnr-logo-white.png";
import dots from "../../Assets/leadership/dot.png";
import LeaderAdvisorySectionimg from "../Leadership/LeaderAdvisorySectionimg";

const steps = [
  {
    number: "01",
    title: "Submit resume and interest statement",
  },
  {
    number: "02",
    title: "Role-based interviews",
  },
  {
    number: "03",
    title: "Final interaction with leadership",
  },
  {
    number: "04",
    title: "Decision & onboarding",
  },
];

export default function ApplicationProcess() {
  return (

    <div>
      <LeaderAdvisorySectionimg />
        {/* <div className="leftdot"><img src={dots} alt="" /></div>
        <div className="rightdot"><img src={dots} alt="" /></div> */}
      <section className="app-process-section">
    
      <div className="app-process-left">
        <div className="app-process-img-wrap">
          <img src={processImg} alt="Application Process" />
          </div>
          {/* <img src={dots} alt="dotpattern" /> */}
      </div>
      <div className="app-process-right">
        <div className="app-process-title">
          Apply today. Build your path to success
          with <img src={vcnrLogo} alt="VCNR Group" className="app-process-logo" /> GROUP
        </div>
        <div className="app-process-desc">
          Applying at VCNR is transparent and human. We review each application with care and our step by step process helps us to find clarity, not just in skillset, but in mission.
        </div>
        <div className="app-process-steps">
          {steps.map((step, idx) => (
            <div className="app-process-step" key={idx}>
              <div className={`app-process-step-num${step.highlight ? " highlight" : ""}`}>{step.number}</div>
              <div className="app-process-step-title">{step.title}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>
    
  );
} 